import { CategoriesBySector } from '../categories-types';

export const CATEGORIES_VENUE_STRUCTURE: CategoriesBySector = {
  '': undefined,
  ANY: undefined,
  TEAM: ['all', 'transport', 'catering'],
  ARTISTS: undefined,
  SITE: [
    'all',
    'scenography',
    'material',
    'building',
    'energy',
    'water',
    'waste',
    'equipment',
  ],
  PUBLIC: ['all', 'catering', 'digital'],
};
